import React, { useContext, useEffect, useState } from "react";
import {
  getModifiedScrollHeight,
  toIsoDate,
} from "../../../../../../../utils/UtilFunctions";
import {
  AtsRfqMstEdge,
  AtsRfqMstOrderField,
  GetRfqsResult,
  GetRfqsVars,
  RfqQueryType,
} from "../../../quotation/queries/types";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../../styles/AutocompleteStyles";
import { GetRfqs } from "../../../quotation/queries/queries";
import { useLazyQuery } from "@apollo/client";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../../../utils/constants";
import { TextField } from "@mui/material";

import useUrlParams from "../../../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../../../context/context";
import { OrderDirection } from "../../../../../../../utils/commonQueryTypes";
import { formDates } from "../../../material/ApprovedList";
import { Props } from "./MRFSelect";
import { GetMrfs, GetMrfsForPO } from "../../../material/queries/queries";
import {
  AtsMrfMstEdge,
  AtsMrfMstOrderField,
  GetMrfsResult,
  GetMrfsVars,
  MrfQueryType,
} from "../../../material/queries/types";

const MRFAutocomplete = ({ value, onChange, onKeyDown, autofocus }: Props) => {
  const [mrfs, setMrfs] = useState<AtsMrfMstEdge[]>([]);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const { customer_id } = useUrlParams();
  const { state } = useContext(AppContext);

 

  const [GetMrf, { loading, data: rfqData, fetchMore }] = useLazyQuery<
    GetMrfsResult,
    GetMrfsVars
  >(GetMrfsForPO);

  const handleScroll = (e: React.UIEvent<HTMLUListElement, UIEvent>) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;
    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !loading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetMrfs.edges;
            const pageInfo = fetchMoreResult.GetMrfs.pageInfo;
            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck = prevResult.GetMrfs.edges.filter(
              ({ node: { id } }) =>
                newEdges.findIndex(
                  ({ node: { id: newId } }) => newId === id
                ) !== -1
            );

            if (duplicateCheck.length > 0) return prevResult;

            return {
              GetMrfs: {
                edges: [...mrfs, ...newEdges],
                pageInfo,
                totalCount: rfqData ? rfqData.GetMrfs.totalCount! : 0,
              },
            };
          },
        });
      }
    }
  };

  useEffect(() => {
    if ( customer_id && state.ActiveFinYr) {
      GetMrf({
        variables: {
         
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          name: EMPTY_STRING,
          end_date: toIsoDate(dates.endDate),
          start_date: toIsoDate(dates.startDate),
          queryType: MrfQueryType.APPROVED_MRFS,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfMstOrderField.MRF_DATE,
          },
        },
      });
    }
  }, [customer_id, state.ActiveFinYr, GetMrf, dates.endDate, dates.startDate]);

  useEffect(() => {
    if (rfqData && !loading) {
      const newData = rfqData.GetMrfs.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = mrfs.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setMrfs(updatedNewData);
      } else {
        setMrfs(newData);
      }
      setEndCursor(rfqData.GetMrfs.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [rfqData, loading]);

  useEffect(() => {
    if (state.ActiveFinYr) {
      setDates({
        endDate: toIsoDate(state.ActiveFinYr.finEndDate),
        startDate: toIsoDate(state.ActiveFinYr.finStDate),
      });
    }
  }, [state.ActiveFinYr]);

  return (
    <FormAutocomplete
      className={formClasses.inputRoot}
      options={mrfs}
      onKeyDown={onKeyDown}
      slotProps={{
        listbox: {
          onScroll: handleScroll,
        },
      }}
      getOptionKey={(option) => (option as AtsMrfMstEdge).node.id}
      getOptionLabel={(option) => (option as AtsMrfMstEdge).node.mrfNo}
      value={value}
      onChange={(e, newValue) => {
        onChange(newValue as AtsMrfMstEdge | null);
      }}
      openOnFocus
      forcePopupIcon
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          autoFocus={autofocus}
          className={formClasses.formControlRoot}
        />
      )}
    />
  );
};

export default MRFAutocomplete;
